import useHookForm from '../../../hooks/forms/useHookForm'
import { validationSchema } from './schema'
import { DEFAULT_VALUES } from './constants'
import { setPassword } from 'services/authenticationService'
import MODAL from 'src/utils/modals'

const useForm = () => {
  const handleResetPassword = async ({ code, newPassword, successCallback, context, setError }) => {
    context.showLoader()
    const { email, authenticationToken } = context.credentials
    const response = await setPassword({ email, password: newPassword, keyCode: code, authenticationToken })
    if (response.status === 201) {
      successCallback({}, true)
      successCallback(MODAL.LOGIN_MODAL({
        onCancel: successCallback,
        callback: successCallback
      }))
    } else {
      setError('code', { type: 'manual', message: 'Código inválido.' })
    }
    context.hideLoader()
  }

  const onSubmitForm = (values, params) => {
    const { successCallback, context, setError } = params

    const { email, code, newPassword } = values
    handleResetPassword({
      email,
      code,
      newPassword,
      successCallback,
      context,
      setError
    })
  }

  const form = useHookForm({
    onSubmitForm,
    validationSchema,
    defaultValues: DEFAULT_VALUES
  })

  return form
}
export default useForm
